import React from 'react';
import { TitleWrapper } from '../Layout.styled';
var HeaderTitle = function (_a) {
    var title = _a.title, headerAddOn = _a.headerAddOn;
    var titleRender = typeof title === 'function' ? title() : title;
    return (React.createElement(TitleWrapper, null,
        titleRender,
        headerAddOn && headerAddOn()));
};
export default HeaderTitle;
